import { Layout, SlideoutDecorator } from "@mcleod/components";
import { ImageName } from "@mcleod/images";
import { AutogenLayoutDriverAlerts } from "./autogen/AutogenLayoutDriverAlerts";

export interface DriverAlertsProps {
    tractorId?: string;
    trailerId?: string;
    driverId?: string;
}

export class DriverAlerts extends AutogenLayoutDriverAlerts {
    public tractorId: string;
    public trailerId: string;
    public driverId: string;

    static openSlideout(props: DriverAlertsProps) {
        const driverAlertsLayout = Layout.getLayout("lme/dispatch/planning/DriverAlerts") as DriverAlerts;
        const { tractorId, trailerId, driverId } = props;
        new SlideoutDecorator({
            layout: driverAlertsLayout,
            fillVerticalSpace: true,
            width: "70%",
            title: `Equipment Alerts`,
            doAfterSlideIn: async () => {
                driverAlertsLayout.tractorId = tractorId;
                driverAlertsLayout.trailerId = trailerId;
                driverAlertsLayout.driverId = driverId;
                await driverAlertsLayout.setupEquipAlerts();
            }
        })
    }

    async setupEquipAlerts() {
        const alertsLayout = this.layoutDispatchEquipAlerts;
        await alertsLayout.mainDataSource.search({units:[this.tractorId, this.driverId, this.trailerId]});
        const rows = alertsLayout.mainDataSource.data;
        const urgentCount = rows.reduce((acc, cur) => cur.get("priority") == "U" ? ++acc : acc, 0);
        const tab = this.tabEquipmentAlerts;
        if(rows.length > 0){
            tab.imageName = ImageName.equipmentAlerts;
        }
        if(urgentCount > 0 ){
            tab.imageName = ImageName.equipmentAlertUrgent;
        }
    }
}
